import { Routes } from '@angular/router';

//components from CoreModule
import { AuthRedirectPage } from '@bayclubs/horizon';
import { authGuard } from './auth/services/auth.guard';
import {
    CampCareBookingComponent,
    CampDetailsComponent,
    CampEnrollmentComponent,
    CampListComponent,
    DashboardComponent,
    LoginComponent,
    PurchaseDetailsComponent,
    PurchaseEditComponent,
    PurchaseListComponent,
    ReportsComponent,
    RosterComponent,
} from './core/core.module';
import { CampCreateComponent } from './core/routes/camp-management/camp-create/camp-create.component';
import { CampImportComponent } from './core/routes/camp-management/camp-import/camp-import.component';
import { CouponDetailsComponent } from './core/routes/coupons/coupon-details/coupon-details.component';
import { CouponsListComponent } from './core/routes/coupons/coupons-list/coupons-list.component';
import { ForbiddenComponent } from './core/routes/forbidden/forbidden.component';
import { ManageImagesComponent } from './core/routes/manage-images/manage-images.component';
import { MembershipListComponent } from './core/routes/membership-list/membership-list.component';
import { SellCampComponent } from './core/routes/sell-camp/sell-camp.component';
import { CanUseCampsGuard } from './infrastructure/guards/can-use-camps.guard';

//todo add child routes for modules RouterModule.forChild(...);
export const appRoutes: Routes = [
    { path: '', component: DashboardComponent, canActivate: [authGuard, CanUseCampsGuard] },
    { path: 'login', component: LoginComponent },
    // MSAL redirect bridge page (AD_REDIRECT_URI)
    { path: 'code', component: AuthRedirectPage },
    { path: 'purchases', component: PurchaseListComponent, canActivate: [authGuard, CanUseCampsGuard] },
    { path: 'purchases/:id/details', component: PurchaseDetailsComponent, canActivate: [authGuard, CanUseCampsGuard] },
    { path: 'purchases/:purchaseSetId/edit', component: PurchaseEditComponent, canActivate: [authGuard, CanUseCampsGuard] },
    { path: 'camps', component: CampListComponent, canActivate: [authGuard, CanUseCampsGuard] },
    { path: 'camps/create', component: CampCreateComponent, canActivate: [authGuard, CanUseCampsGuard] },
    { path: 'camps/import', component: CampImportComponent, canActivate: [authGuard, CanUseCampsGuard] },
    { path: 'camps/:id/details', component: CampDetailsComponent, canActivate: [authGuard, CanUseCampsGuard] },
    { path: 'camps/:id/enrollment', component: CampEnrollmentComponent, canActivate: [authGuard, CanUseCampsGuard] },
    { path: 'camps/:id/booking', component: CampCareBookingComponent, canActivate: [authGuard, CanUseCampsGuard] },
    { path: 'roster', component: RosterComponent, canActivate: [authGuard, CanUseCampsGuard] },
    { path: 'coupons', component: CouponsListComponent, canActivate: [authGuard, CanUseCampsGuard] },
    { path: 'coupons/:id/details', component: CouponDetailsComponent, canActivate: [authGuard, CanUseCampsGuard] },
    { path: 'reports', component: ReportsComponent, canActivate: [authGuard, CanUseCampsGuard] },
    { path: 'memberships', component: MembershipListComponent, canActivate: [authGuard, CanUseCampsGuard] },
    { path: 'sell', component: SellCampComponent, canActivate: [authGuard, CanUseCampsGuard] },
    { path: 'manage-images', component: ManageImagesComponent, canActivate: [authGuard, CanUseCampsGuard] },
    { path: 'forbidden', component: ForbiddenComponent },
];
